


import React, { useState, useEffect, useContext } from "react";
import {
  AppBar,
  Typography,
  Button,
  IconButton,
  TextField,
  Box,
  Breadcrumbs,
  Autocomplete,
  useMediaQuery,
  InputAdornment,
  Link,
} from "@mui/material";

import Grid from "@mui/material/Grid2";
import { useNavigate } from "react-router-dom";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import { Doctypedata, sampleData } from "../../components/grid/GridData";
import { externalgetApi } from "../../services/externalApis";
import { SETTING_API_01, SETTING_API_03, SETTING_API_09 } from "../../api/ApiModel";
import ViewDataGrid from "../../components/grid/ViewDataGrid";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import SearchIcon from "@mui/icons-material/Search";
import { PageDataContext } from "../../utils/common/PageDataContext";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
import { useSelector } from "react-redux";
import CommentsDisabledIcon from '@mui/icons-material/CommentsDisabled';
function ViewDocumentType() {
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const { setPageData } = useContext(PageDataContext);
  const SYS_USER = useSelector((state) => state.user) || {};
  const {    LOCCODE,STAFFMAPLOCODE,COMPCODE, } = SYS_USER.USER_PARAM || {};
  const [isLoading, setIsLoading] = useState(false);
 const [datadoccat, setDatadoccat] = useState(null);
  const [data, setData] = useState(null);
  const [error, setError] = useState({});
    const [selectedDoccatcode, setSelectedDoccatcode] = useState("");
  const [statusFilter, setStatusFilter] = useState("A"); // 'A' for Active, 'D' for Disabled
  useEffect(() => {
    setPageData({
      title: "Document Types",
      // icon: <HomeIcon />,
      // showBackButton: false,
      // customActions: <button>Refresh</button>,
      // breadcrumbs: ["Home", "Dashboard"],
    });
  }, []);
  const [filteredRows, setFilteredRows] = useState([]);
  const [searchQuery, setSearchQuery] = useState(""); // State for search input

 useEffect(() => {
    if (Array.isArray(datadoccat) && datadoccat.length > 0) {
      setSelectedDoccatcode(datadoccat[0].doccatcode);
    }
  }, [datadoccat]);

  const handleItemClick = (id, actionText) => {
    if (actionText === "Edit") {
      const selectedItem = data.find((item) => item.doctypecode === id);
      const selectedCategory = datadoccat?.find((item) => item.doccatcode === selectedItem?.doccatcode);
      if (selectedItem) {
        navigate("/CreateDocumentTypes", {
          state: {
            selectedItem,
            actionText,
            selectedDoccatcode: selectedCategory?.doccatcode || "",
            selectedDoccatname: selectedCategory?.doccatname || "",
          },
        });
      }
    }
  };

     const menuItems = [
      {
        text: "Edit",
        icon: <BorderColorOutlinedIcon />,
      onClick: (doctypecode) => handleItemClick(doctypecode, "Edit"),
      },
    ];

  useEffect(() => {
    const fetchData = async () => {
      if (!selectedDoccatcode) return; // Skip API call if no doccatcode is selected
  
      try {
        const result = await externalgetApi(SETTING_API_03, "get", {
          COMPCODE,
          LOCCODE: STAFFMAPLOCODE,
          DOCCATCODE: selectedDoccatcode, // Pass the selected doccatcode
          STS: CON_STATUS_ACTIVE,
        });
        console.log("API result for selectedDoccatcode:", result);
        setData(result);
        setFilteredRows(result);
      } catch (err) {
        console.error("Error fetching data for selectedDoccatcode:", err);
      }
    };
  
    fetchData();
  }, [selectedDoccatcode]); // Trigger API call when selectedDoccatcode changes



  useEffect(() => {
    const fetchData = async () => {
      try {
      const result = await externalgetApi(SETTING_API_09, "get", {
  
    
    
          STS: CON_STATUS_ACTIVE,
        });

        setDatadoccat(result);
    
      console.log("result", result);
        setIsLoading(false);
      } catch (err) {
        setError(err);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  // Handle search input change
  const handleSearchChange = (event, value) => {
    setSearchQuery(value); // Update search query state

    // Filter rows based on search query
    const filtered = data?.filter((row) =>
      row.doctype.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredRows(filtered || []);
  };


  const addToView = () => {
       const selectedCategory = datadoccat?.find((item) => item.doccatcode === selectedDoccatcode);
    navigate("/CreateDocumentTypes", {
      state: {
        actionText: "Add",
        selectedDoccatcode: selectedCategory?.doccatcode || "",
        selectedDoccatname: selectedCategory?.doccatname || "",
      },
    } );
  };

  useEffect(() => {
    if (Array.isArray(datadoccat) && datadoccat.length > 0) {
      setSelectedDoccatcode(datadoccat[0].doccatcode); // Set the first item's doccatcode as default
    }
  }, [datadoccat]); // Trigger when datadoccat changes

  

  return (
    <>
      <Box sx={styles.box_breadcrumb_view}>
     <Breadcrumbs
                 separator="›"
                 aria-label="breadcrumb"
                 sx={styles.breadcrumb}
               >
                 <Link
                   underline="hover"
                   sx={styles.breadcrumb_link}
                   // href=""
                 >
                   Home
                 </Link>
                 <Link
                   sx={styles.breadcrumb_link}
                   underline="hover"
                   // href=""
                 >
                   Settings
                 </Link>
                 <Link
                   sx={styles.breadcrumb_link_page}
                   underline="hover"
                   // href="#"
                   aria-current="page"
                 >
                   Document Type
                 </Link>
               </Breadcrumbs>
      </Box>

      <Box sx={styles.box_page_container}>
        <AppBar sx={styles.appbar}>
          <Grid container spacing={2} sx={styles.appbar_grid_container}>
            <Grid
              item
              size={{ xs: 12, sm: 12, md: 6, lg: 4, xl: 8 }}
              sx={styles.appbar_grid_container_col_1}
            >
              <Typography sx={styles.appbar_title}>
                {Doctypedata.name}
              </Typography>
            </Grid>

            <Grid
              item
              size={{ xs: 12, sm: 12, md: 6, lg: 8, xl: 4 }}
              sx={styles.appbar_grid_search}
            >



<Autocomplete
  options={Array.isArray(datadoccat) ? datadoccat : []} // Ensure datadoccat is an array
  getOptionLabel={(option) => option.doccatname || ""} // Use doccatname or fallback to an empty string
  disableClearable
  fullWidth
  value={
    Array.isArray(datadoccat)
      ? datadoccat.find((item) => item.doccatcode === selectedDoccatcode) || null
      : null
  } // Match the selected value or fallback to null
  onChange={(event, newValue) => {
    const doccatcode = newValue ? newValue.doccatcode : "";
    console.log("Selected doccatcode:", doccatcode);
    setSelectedDoccatcode(doccatcode);
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      label={
        <span>
          Document Category Name<span style={{ color: "red" }}> *</span>
        </span>
      }
      variant="outlined"
      error={!!error?.doccatcode} // Show error if doccatcode has an issue
      helperText={error?.doccatcode} // Display helper text for the error
      size="small"
      name="doccatcode"
    />
  )}
  ListboxProps={{
    style: {
      maxHeight: 150,
      backgroundColor: theme.palette.background.paper,
    },
  }}
/>

{/* <Autocomplete
  options={[
    { label: "Enable", value: "A" },
    { label: "Disable", value: "D" },
  ]}
  getOptionLabel={(option) => option.label}
  disableClearable
  fullWidth
  value={{ label: statusFilter === "A" ? "Enable" : "Disable", value: statusFilter }}
  onChange={(event, newValue) => {
    setStatusFilter(newValue.value);
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      label="Status"
      variant="outlined"
      size="small"
    />
  )}
  ListboxProps={{
    style: {
      maxHeight: 150,
      backgroundColor: theme.palette.background.paper,
    },
  }}
/> */}


             <Autocomplete
                freeSolo
                id="sample-search"
                fullWidth
                disableClearable
                value={searchQuery}
                onInputChange={handleSearchChange} // Handle search input change
                sx={styles.ipt_appbar_search_auto}
                options={data?.map((row) => row.doctype) || []} // Provide options for autocomplete
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Search by..."
                    size="small"
                    sx={styles.ipt_appbar_search}
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton sx={styles.btn_appbar_search_icon}>
                            <SearchIcon />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              />

      


              <Button
                variant="contained"
                startIcon={<AddCircleOutlineIcon />}
                size="small"
                sx={{ ...styles.btn_primary, ...styles.btn_appbar_add }}
                onClick={addToView}
              >
                Add
              </Button>
            </Grid>
          </Grid>
        </AppBar>

        <Box sx={styles.view_page_container}>
        <ViewDataGrid
  columns={Doctypedata.columns}
 
  rows={(filteredRows || []).map((row) => ({
    ...row,
    id: row.doctypecode || Math.random(), // Ensure each row has a unique id
  }))}
  getRowId={(row) => row.id} // Use the id property for unique identification
  isLoading={isLoading}
  menuItems={menuItems}
  tabletitle={Doctypedata.name}
  gridid="doctypecode"
  sx={styles.view_data_grid_page}
/>
        </Box>
      </Box>
    </>
  );
}
export default ViewDocumentType;
